"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var kb_utilities_1 = require("../kb.utilities");
function kbReducer(state, action) {
    if (state === void 0) { state = (_a = {
            categories: (_b = {},
                _b[skynet_store_kb_api_1.defaultKbKey] = undefined,
                _b),
            fields: (_c = {},
                _c[skynet_store_kb_api_1.defaultKbKey] = immutable_1.Map(),
                _c),
            groups: (_d = {},
                _d[skynet_store_kb_api_1.defaultKbKey] = immutable_1.Map(),
                _d),
            mainEntityFields: (_e = {},
                _e[skynet_store_kb_api_1.defaultKbKey] = immutable_1.Map(),
                _e),
            hierarchicalCategories: (_f = {},
                _f[skynet_store_kb_api_1.defaultKbKey] = undefined,
                _f)
        },
        _a[skynet_store_manager_1.loadingStatusKey] = {},
        _a); }
    var prefix;
    switch (action.type) {
        // region category
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS):
            {
                var actualAction = action;
                prefix = extractPrefix(actualAction.additionalData);
                return __assign({}, state, (_g = { categories: __assign({}, state.categories, (_h = {}, _h[prefix] = actualAction.items.toList(), _h)) }, _g[skynet_store_manager_1.loadingStatusKey] = immutable_1.setIn(state[skynet_store_manager_1.loadingStatusKey], ['categories', prefix], true), _g));
            }
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ALL): {
            var actualAction = action;
            return __assign({}, state, { categories: __assign({}, state.categories, (_j = {}, _j[extractPrefix(actualAction.additionalData)] = immutable_1.List(), _j)) });
        }
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS):
            {
                var actualAction = action;
                var category_1 = actualAction.item;
                prefix = extractPrefix(actualAction.additionalData);
                if (lodash_1.isNil(state.categories[prefix])) {
                    state.categories[prefix] = immutable_1.List();
                }
                var index = lodash_1.get(state.categories, prefix, immutable_1.List()).findIndex(function (value) {
                    return value.metaCategoryId.systemName ===
                        category_1.metaCategoryId.systemName;
                });
                var categories = index > -1
                    ? lodash_1.get(state.categories, prefix, immutable_1.List()).set(index, category_1)
                    : lodash_1.get(state.categories, prefix, immutable_1.List()).push(category_1);
                return __assign({}, state, { categories: __assign({}, state.categories, (_k = {}, _k[prefix] = categories, _k)) });
            }
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS):
            {
                var addCategorySuccess = action;
                prefix = extractPrefix(addCategorySuccess.additionalData);
                if (lodash_1.isNil(state.categories[prefix])) {
                    state.categories[prefix] = immutable_1.List();
                }
                return __assign({}, state, { categories: __assign({}, state.categories, (_l = {}, _l[prefix] = state.categories[prefix].push(addCategorySuccess.item), _l)) });
            }
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_SUCCESS):
            {
                var addCategorySuccess_1 = action;
                prefix = extractPrefix(addCategorySuccess_1.additionalData);
                var categoryIndex = lodash_1.get(state.categories, prefix, immutable_1.List()).findIndex(function (value) {
                    return value.metaCategoryId.systemName ===
                        addCategorySuccess_1.item.metaCategoryId.systemName;
                });
                return __assign({}, state, { categories: __assign({}, state.categories, (_m = {}, _m[prefix] = lodash_1.get(state.categories, prefix, immutable_1.List()).set(categoryIndex, addCategorySuccess_1.item), _m)) });
            }
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS):
            {
                var deleteCategorySuccess = action;
                prefix = extractPrefix(deleteCategorySuccess.additionalData);
                var deletedCategory_1 = deleteCategorySuccess.item;
                var deleteFields = state.fields[prefix].get(deletedCategory_1.metaCategoryId.systemName);
                var removableCategoryNames_1 = [
                    deletedCategory_1.metaCategoryId.systemName,
                ];
                if (deleteFields) {
                    removableCategoryNames_1.push.apply(removableCategoryNames_1, deleteFields
                        .filter(function (f) {
                        return f.metaFieldType === 'SUB_ENTITY' &&
                            f.subEntityMetaCategoryId;
                    })
                        .map(function (f) { return f.subEntityMetaCategoryId.systemName; })
                        .toArray());
                }
                var fields = state.fields[prefix].removeAll(removableCategoryNames_1);
                if (!deletedCategory_1.isClassifier &&
                    !deletedCategory_1.isWithVersioning) {
                    fields = fields.mapEntries(function (entry) { return [
                        entry[0],
                        entry[1].filter(function (field) {
                            return !field.subEntityMetaCategoryId ||
                                field.subEntityMetaCategoryId.systemName !==
                                    deletedCategory_1.metaCategoryId.systemName;
                        }),
                    ]; });
                }
                return __assign({}, state, { groups: __assign({}, state.groups, (_o = {}, _o[prefix] = state.groups[prefix].removeAll(removableCategoryNames_1), _o)), categories: __assign({}, state.categories, (_p = {}, _p[prefix] = lodash_1.get(state.categories, prefix, immutable_1.List()).filter(function (value) {
                        return lodash_1.isNil(removableCategoryNames_1.find(function (categoryName) {
                            return value.metaCategoryId.systemName ===
                                categoryName;
                        }));
                    }), _p)), fields: __assign({}, state.fields, (_q = {}, _q[prefix] = fields, _q)) });
            }
        // endregion
        // region field
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS):
            {
                var fieldLoadSuccess = action;
                prefix = extractPrefix(fieldLoadSuccess.additionalData);
                if (lodash_1.isNil(state.fields[prefix])) {
                    state.fields[prefix] = immutable_1.Map();
                }
                return __assign({}, state, (_r = { fields: __assign({}, state.fields, (_s = {}, _s[prefix] = state.fields[prefix].set(fieldLoadSuccess.subPath, fieldLoadSuccess.items.toList()), _s)) }, _r[skynet_store_manager_1.loadingStatusKey] = immutable_1.setIn(state[skynet_store_manager_1.loadingStatusKey], ['fields', prefix, fieldLoadSuccess.subPath], true), _r));
            }
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE_SUCCESS):
            {
                var fieldAction_1 = action;
                prefix = extractPrefix(fieldAction_1.additionalData);
                if (!state.fields[prefix].has(fieldAction_1.subPath)) {
                    state.fields[prefix].set(fieldAction_1.subPath, immutable_1.List());
                }
                var metaFields = state.fields[prefix].get(fieldAction_1.subPath);
                var index = metaFields.findIndex(function (value) {
                    return value.metaFieldId.systemName ===
                        fieldAction_1.item.metaFieldId.systemName;
                });
                var fields = index > -1
                    ? metaFields.set(index, fieldAction_1.item)
                    : metaFields.push(fieldAction_1.item);
                if (lodash_1.isNil(state.fields[prefix])) {
                    state.fields[prefix] = immutable_1.Map();
                }
                return __assign({}, state, { fields: __assign({}, state.fields, (_t = {}, _t[prefix] = state.fields[prefix].set(fieldAction_1.subPath, fields), _t)) });
            }
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS):
            {
                var addFieldAction_1 = action;
                prefix = extractPrefix(addFieldAction_1.additionalData);
                var fields = state.fields[prefix].update(addFieldAction_1.subPath, immutable_1.List(), function (value) { return value.push(addFieldAction_1.item); });
                var _u = lodash_1.get(state.categories, prefix, immutable_1.List()).findEntry(function (cat) { return cat.metaCategoryId.systemName === addFieldAction_1.subPath; }), currentCategoryIndex = _u[0], currentCategory = _u[1];
                var clonedCategory = kb_utilities_1.cloneCategory(currentCategory);
                clonedCategory.metaFieldIds = clonedCategory.metaFieldIds.push(addFieldAction_1.item.metaFieldId);
                var categories = lodash_1.get(state.categories, prefix, immutable_1.List()).set(currentCategoryIndex, clonedCategory);
                return __assign({}, state, { fields: __assign({}, state.fields, (_v = {}, _v[prefix] = fields, _v)), categories: __assign({}, state.categories, (_w = {}, _w[prefix] = categories, _w)) });
            }
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS):
            {
                var updateManyFieldsAction_1 = action;
                prefix = extractPrefix(updateManyFieldsAction_1.additionalData);
                var updatedItems_1 = updateManyFieldsAction_1.items
                    .toMap()
                    .mapKeys(function (key, value) { return value.metaFieldId.systemName; });
                var fields = state.fields[prefix].update(updateManyFieldsAction_1.subPath, immutable_1.List(), function (value) {
                    return value.map(function (field) {
                        if (updatedItems_1.has(field.metaFieldId.systemName)) {
                            return kb_utilities_1.cloneEntity(updatedItems_1.get(field.metaFieldId.systemName));
                        }
                        else {
                            return field;
                        }
                    });
                });
                var _x = lodash_1.get(state.categories, prefix, immutable_1.List()).findEntry(function (cat) {
                    return cat.metaCategoryId.systemName ===
                        updateManyFieldsAction_1.subPath;
                }), currentCategoryIndex = _x[0], currentCategory = _x[1];
                var clonedCategory = kb_utilities_1.cloneCategory(currentCategory);
                clonedCategory.keyMetaFieldIds = fields
                    .get(updateManyFieldsAction_1.subPath)
                    .filter(function (value) { return value.isKeyField; })
                    .map(function (value) { return value.metaFieldId; });
                clonedCategory.nameMetaFieldIds = fields
                    .get(updateManyFieldsAction_1.subPath)
                    .filter(function (value) { return value.isName; })
                    .map(function (value) { return value.metaFieldId; });
                var categories = lodash_1.get(state.categories, prefix, immutable_1.List()).set(currentCategoryIndex, clonedCategory);
                return __assign({}, state, { fields: __assign({}, state.fields, (_y = {}, _y[prefix] = fields, _y)), categories: __assign({}, state.categories, (_z = {}, _z[prefix] = categories, _z)) });
            }
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS):
            {
                var deleteFieldSuccess_1 = action;
                prefix = extractPrefix(deleteFieldSuccess_1.additionalData);
                var deleteFieldId_1 = deleteFieldSuccess_1.item.metaFieldId.systemName;
                var categoryIndex = lodash_1.get(state.categories, prefix, immutable_1.List()).findIndex(function (category) {
                    return category.metaCategoryId.systemName ===
                        deleteFieldSuccess_1.subPath;
                });
                var categories = lodash_1.get(state.categories, prefix, immutable_1.List());
                if (categoryIndex >= 0) {
                    var clonedCategory = kb_utilities_1.cloneCategory(lodash_1.get(state.categories, prefix, immutable_1.List()).get(categoryIndex));
                    clonedCategory.actionDataMetaFieldIds = clonedCategory.actionDataMetaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.keyMetaFieldIds = clonedCategory.keyMetaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.metaFieldIds = clonedCategory.metaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.nameMetaFieldIds = clonedCategory.nameMetaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.searchableFieldIds = clonedCategory.searchableFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.systemMetaFieldIds = clonedCategory.systemMetaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    clonedCategory.transientMetaFieldIds = clonedCategory.transientMetaFieldIds.filter(function (field) { return field.systemName !== deleteFieldId_1; });
                    categories = categories.set(categoryIndex, clonedCategory);
                }
                if (deleteFieldSuccess_1.item.metaFieldType === 'SUB_ENTITY' &&
                    skynet_store_utilities_1.notNil(deleteFieldSuccess_1.item.subEntityMetaCategoryId)) {
                    categories = categories.filter(function (cat) {
                        return cat.metaCategoryId.systemName !==
                            deleteFieldSuccess_1.item.subEntityMetaCategoryId
                                .systemName;
                    });
                }
                return __assign({}, state, { categories: __assign({}, state.categories, (_0 = {}, _0[prefix] = categories, _0)), fields: __assign({}, state.fields, (_1 = {}, _1[prefix] = state.fields[prefix].set(deleteFieldSuccess_1.subPath, state.fields[prefix]
                        .get(deleteFieldSuccess_1.subPath)
                        .filter(function (field) {
                        return field.metaFieldId.systemName !==
                            deleteFieldId_1;
                    })), _1)) });
            }
        // endregion
        // region group
        case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS):
            var groupLoadSuccess = action;
            prefix = extractPrefix(groupLoadSuccess.additionalData);
            if (lodash_1.isNil(state.groups[prefix])) {
                state.groups[prefix] = immutable_1.Map();
            }
            return __assign({}, state, (_2 = { groups: __assign({}, state.groups, (_3 = {}, _3[prefix] = state.groups[prefix].set(groupLoadSuccess.subPath, groupLoadSuccess.items.toList()), _3)) }, _2[skynet_store_manager_1.loadingStatusKey] = immutable_1.setIn(state[skynet_store_manager_1.loadingStatusKey], ['groups', prefix, groupLoadSuccess.subPath], true), _2));
        case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.CREATE_SUCCESS):
            {
                var addGroupAction_1 = action;
                prefix = extractPrefix(addGroupAction_1.additionalData);
                var groups = state.groups[prefix].update(addGroupAction_1.subPath, immutable_1.List(), function (existingGroups) {
                    if (skynet_store_utilities_1.notNil(existingGroups.find(function (g) {
                        return g.equals(addGroupAction_1.item);
                    }))) {
                        return existingGroups;
                    }
                    return existingGroups.push(addGroupAction_1.item);
                });
                var _4 = lodash_1.get(state.categories, prefix, immutable_1.List()).findEntry(function (cat) { return cat.metaCategoryId.systemName === addGroupAction_1.subPath; }), currentCategoryIndex = _4[0], currentCategory = _4[1];
                var clonedCategory = kb_utilities_1.cloneCategory(currentCategory);
                var categories = lodash_1.get(state.categories, prefix, immutable_1.List()).set(currentCategoryIndex, clonedCategory);
                clonedCategory.groupIds = clonedCategory.groupIds.push({
                    systemName: addGroupAction_1.item.systemName,
                    metaCategoryId: clonedCategory.metaCategoryId,
                });
                return __assign({}, state, { groups: __assign({}, state.groups, (_5 = {}, _5[prefix] = groups, _5)), categories: __assign({}, state.categories, (_6 = {}, _6[prefix] = categories, _6)) });
            }
        case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.UPDATE_MANY_SUCCESS):
            {
                var updateGroupAction = action;
                prefix = extractPrefix(updateGroupAction.additionalData);
                var updatedGroups_1 = updateGroupAction.items
                    .toMap()
                    .mapKeys(function (_, v) { return v.systemName; });
                var groups = state.groups[prefix].update(updateGroupAction.subPath, immutable_1.List(), function (value) {
                    return value.map(function (group) {
                        return updatedGroups_1.has(group.systemName)
                            ? updatedGroups_1.get(group.systemName)
                            : group;
                    });
                });
                return __assign({}, state, { groups: __assign({}, state.groups, (_7 = {}, _7[prefix] = groups, _7)) });
            }
        case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS):
            {
                var deleteGroupAction_1 = action;
                prefix = extractPrefix(deleteGroupAction_1.additionalData);
                var groups = state.groups[prefix].update(deleteGroupAction_1.subPath, immutable_1.List(), function (value) {
                    return value.filter(function (group) {
                        return group.systemName !== deleteGroupAction_1.item.systemName;
                    });
                });
                var _8 = lodash_1.get(state.categories, prefix, immutable_1.List()).findEntry(function (cat) {
                    return cat.metaCategoryId.systemName === deleteGroupAction_1.subPath;
                }), currentCategoryIndex = _8[0], currentCategory = _8[1];
                var clonedCategory = kb_utilities_1.cloneCategory(currentCategory);
                clonedCategory.groupIds = clonedCategory.groupIds.filter(function (groupId) {
                    return groupId.systemName === deleteGroupAction_1.item.systemName;
                });
                return __assign({}, state, { groups: __assign({}, state.groups, (_9 = {}, _9[prefix] = groups, _9)), categories: __assign({}, state.categories, (_10 = {}, _10[prefix] = lodash_1.get(state.categories, prefix, immutable_1.List()).set(currentCategoryIndex, clonedCategory), _10)) });
            }
        // endregion
        case skynet_store_kb_api_1.KbActionTypes.LoadMainEntityFieldNamesSuccess: {
            var actualAction = action;
            prefix = actualAction.prefix ? actualAction.prefix : skynet_store_kb_api_1.defaultKbKey;
            var categoryName = actualAction.mainEntityField.metaCategoryId.systemName;
            var fieldName = actualAction.mainEntityField.systemName;
            if (lodash_1.isNil(state.mainEntityFields[prefix])) {
                state.mainEntityFields[prefix] = immutable_1.Map();
            }
            return __assign({}, state, { mainEntityFields: __assign({}, state.mainEntityFields, (_11 = {}, _11[prefix] = state.mainEntityFields[prefix].set(categoryName, state.mainEntityFields[prefix]
                    .get(categoryName, immutable_1.Map())
                    .set(fieldName, actualAction.mainEntityMetaFieldNames)), _11)) });
        }
        case skynet_store_kb_api_1.KbActionTypes.LoadHierarchicalCategoriesSuccess: {
            var actualAction = action;
            prefix = actualAction.prefix ? actualAction.prefix : skynet_store_kb_api_1.defaultKbKey;
            // Do not Optimize
            var data = actualAction.hierarchicalMetaCategories;
            return __assign({}, state, { hierarchicalCategories: __assign({}, state.hierarchicalCategories, (_12 = {}, _12[prefix] = data, _12)) });
        }
        case skynet_store_kb_api_1.groupStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
        case skynet_store_kb_api_1.fieldStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
        case skynet_store_kb_api_1.categoryStoreManager().actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR):
            var errorAction = action;
            return __assign({}, state, { error: errorAction.error });
        default:
            return state;
    }
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _v, _w, _y, _z, _0, _1, _2, _3, _5, _6, _7, _9, _10, _11, _12;
}
exports.kbReducer = kbReducer;
function extractPrefix(additionalData) {
    return additionalData
        ? additionalData['__prefix__']
            ? additionalData['__prefix__']
            : skynet_store_kb_api_1.defaultKbKey
        : skynet_store_kb_api_1.defaultKbKey;
}
exports.extractPrefix = extractPrefix;
//# sourceMappingURL=kb.reducers.js.map